import React from 'react';
import envConfig from '../../../../envConfig';

function RedirectToGatewayPage() {
  return (
    <>
      {window.location.assign(`${envConfig.raaUrl}/gateway`)}
    </>
  );
}

export default RedirectToGatewayPage;
